<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { Smiley } from "$components/+blocks/OVIcon";

  export let size: string = "size-5";
  export let customIconSize: string = "size-3";
</script>

<span
  class="{size} flex items-center justify-center rounded bg-neutral-100 text-neutral-500 dark:bg-neutral-300 dark:text-neutral-600"
>
  <OVIcon icon={Smiley} size={customIconSize} />
</span>
